import { Component, inject, Inject } from '@angular/core';
import { ModalLayoutComponent } from '../modal-layout/modal-layout.component';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatLabel } from '@angular/material/form-field';
import { PageService } from '../../../services/page.service';
import { PageModel } from '../../../models/page.models';
import { NewsService } from '../../../services/news.service';

@Component({
  selector: 'app-modal-feedback-news',
  imports: [
    ModalLayoutComponent,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatFormField,
    ReactiveFormsModule,
  ],
  templateUrl: './modal-feedback-news.component.html',
  standalone: true,
  styleUrl: './modal-feedback-news.component.scss',
})
export class ModalFeedbackNewsComponent {
  page: PageModel | null = null;
  pageService = inject(PageService);
  feedbackForm: FormGroup;
  selectedFile: File | null = null;
  private dialogRef = inject(MatDialogRef<ModalFeedbackNewsComponent>);
  private newsService = inject(NewsService);

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { newsId: string },
  ) {
    this.feedbackForm = this.fb.group({
      organisation: ['', Validators.required],
      fullName: ['', Validators.required],
      description: ['', Validators.required],
      newsId: [data.newsId, Validators.required],
    });
    this.pageService.getPage('announcements').subscribe((page) => {
      this.page = page;
    });
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      this.selectedFile = input.files[0];
    }
  }

  onSubmit() {
    if (this.feedbackForm.valid) {
      const formData = new FormData();
      formData.append('organisation', this.feedbackForm.value.organisation);
      formData.append('fullName', this.feedbackForm.value.fullName);
      formData.append('description', this.feedbackForm.value.description);
      formData.append('newsId', this.feedbackForm.value.newsId);
      if (this.selectedFile) {
        formData.append('file', this.selectedFile);
      }
      this.newsService.createNewsSupport(formData).subscribe(
        (res) => {
          this.dialogRef.close(true);
        },
        (err) => {
          console.error(err);
        },
      );
    }
  }
}
